import { Grid, IconButton } from "@mui/material";
import { FnBlock_UI } from "components/BlockUI";
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { BsFillCameraFill } from "react-icons/bs";
import { RadioForm, SelectFormItem, TextBoxForm } from "components/Input";
import { BtnBack, BtnSave, BtnSaveIcon, BtnCancelIcon } from "components/Button";
import { OptionsStatus, undefinedOrNull } from 'utilities/Function';
import { GetDataAll, GetDataFormID, SaveData } from "./CallAPI";
import { SwAlert } from "components";
import { AlertMsg, AlertTitle } from 'config/AlertMsgConfig';
import { RemoveRedEye, VisibilityOff } from "@mui/icons-material";
import { SendAPIFile } from "utilities/Axios";

export default function AdminUser_From() {

    //#region State
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [ArrRoleType, SetArrRoleType] = useState([{ value: "1", label: "ผู้ดูแลระบบ", }, { value: "2", label: "ฝ่ายทรัพยากรบุคคล", }, { value: "3", label: "ฝ่ายสรรหาบุคลากร", }] as any);
    // const ArrStatus = [{ value: "1", label: "ใช้งาน", }, { value: "0", label: "ไม่ใช้งาน", }];
    // const [nAdminID, SetnAdminID] = useState(0);  

    const navigate = useNavigate();
    const location = useLocation();
    const nID = (location.state != null && location.state["nID"] != undefined) ? location.state["nID"] : null;
    const sMode = (location.state != null && location.state["sMode"] != undefined) ? location.state["sMode"] : null;
    // const [IsPemission, SetIsPemission] = useState(false);  //True แก้ไข / False ดู
    const [IsView, SetView] = useState(false);  //True ดู / False แก้ไข
    const [IsTypePass, SetIsTypePass] = useState(true);
    const [ObjFileImg, SetObjFileImg] = useState(null);    
    //#endregion

    //#region Form YUP
    const objSchema = yup.object().shape({
        sImageURL: yupFormSchemas.string("รูปภาพ", { required: false }),
        sFirstName: yupFormSchemas.string("ชื่อ", { required: true }),
        sLastName: yupFormSchemas.string("นามสกุล", { required: true }),
        sUserName: yupFormSchemas.string("ชื่อผู้ใช้งาน", { required: true }),
        // sPassword: yupFormSchemas.string("รหัสผ่านผู้ใช้งาน", { required: true }),
        sPassword: yupFormSchemas.string("รหัสผ่านผู้ใช้งาน", { required: true, max: 25, matches: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]])(?=.{8,}))/, labelmatches: (`รหัสผ่านไม่ผ่านเงื่อนไขที่กำหนด เช่น Teat@1234`) }),
        sEmail: yupFormSchemas.email("อีเมล์", { required: true }),
        sPhone: yupFormSchemas.string("เบอร์โทร", { required: true }),
        nRoleID: yupFormSchemas.string("ตำแหน่ง", { required: true }),
        IsStatus: yupFormSchemas.string("สถานะ", { required: true }),
    });
    const [initialValues] = useState(() => {
        return ({
            sImageURL: null,
            sFirstName: null,
            sLastName: null,
            sUserName: null,
            sPassword: null,
            sEmail: null,
            sPhone: null,
            nRoleID: null,
            IsStatus: true,
        });
    });
    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        shouldUnregister: false,
        // criteriaMode: "firstError",
        defaultValues: initialValues as any,
    });
    //#endregion
    
    //#region FN
    useEffect(() => {
        onGetDataAll();
        if(nID) onGetDataFormID();
        if(sMode === "View") SetView(true);
    }, [])

    const onGetDataAll = () => {
        GetDataAll((result) => {
            SetArrRoleType(result.ArrRoleType ?? []);
            // //สิทธิ์ User ต้องเป็น Admin เท่านั้นถึงมีสิทธิ์เห็นเมนูนี้ ถ้าไม่ใช่ไม่มีสิทธิ์เห็น
            // SetIsPemission(result.IsPemission); //True แก้ไข / False ดู
        });
    }
    
    const onSaveData = () => {
        let ObjForm = form.getValues();
        let ObjData = {
            nID: nID ?? 0,
            ObjFileImg: ObjFileImg,
            sImageURL: null, //undefinedOrNull(ObjForm.sImageURL, "string"),
            sFirstName: undefinedOrNull(ObjForm.sFirstName, "string"),
            sLastName: undefinedOrNull(ObjForm.sLastName, "string"),
            sUserName: undefinedOrNull(ObjForm.sUserName, "string"),
            sPassword: undefinedOrNull(ObjForm.sPassword, "string"),
            sEmail: undefinedOrNull(ObjForm.sEmail, "string"),
            sPhone: undefinedOrNull(ObjForm.sPhone, "string"),
            nRoleID: undefinedOrNull(ObjForm.nRoleID, "number"),
            IsStatus: undefinedOrNull(ObjForm.IsStatus, "bool"),
        };
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmSave, () => {
            SaveData(ObjData, (result) => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.SaveComplete, () => { onGotoBackList(); });
            }, BlockUI, UnBlockUI);
        });
    };

    const onGetDataFormID = () => {        
        GetDataFormID({nID: +nID}, (result) => {
            console.log("From Admin > GetDataFormID", result); 
            form.setValue("sImageURL", result.sImageURL);    
            SetObjFileImg(result.ObjFileImg);
            form.setValue("sFirstName", result.sFirstName);    
            form.setValue("sLastName", result.sLastName);    
            form.setValue("sUserName", result.sUserName);    
            form.setValue("sPassword", result.sPassword);    
            form.setValue("sEmail", result.sEmail);    
            form.setValue("sPhone", result.sPhone);            
            form.setValue("nRoleID", result.nRoleID +"");    
            form.setValue("IsStatus", result.IsStatus);    
        }, BlockUI, UnBlockUI);
    };

    const onGotoBackList = () => {
        navigate(`/AdminUser`);
    }

    const onUploadFile = () => {
        const onClickFile = document.getElementById("onCameraFile");
        if (onClickFile) {
          onClickFile.click();
        }
    }

    const _SendAPIFile = async (FileItem) => {
        let lstFile_ = FileItem.target.files;
        // console.log("arrFileItem", lstFile_[0]);
        await SendAPIFile(lstFile_[0], (res) => {
        //   console.log("s", res);
          SetObjFileImg(res[0]);
        }, (er) => {
          console.log("er", er);
        });    
    }
    //#endregion

    return (
        <FormProvider {...form}>
            <Grid container direction="row" xs={12} md={12} spacing={1}>
                <Grid container direction="row" xs={12} md={2} alignItems="start" justifyContent="start">
                    <div className="uploadimg" style={{ backgroundImage: ObjFileImg?.sFileUrl ? "url(" + ObjFileImg?.sFileUrl + ")" : "" }} >
                        <div className="image-upload">
                            <input style={{ display: "none" }} type="file" id="onCameraFile" accept="image/*" onChange={_SendAPIFile} />
                            <div className="file-input" onClick={onUploadFile} >
                                <BsFillCameraFill />
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid container direction="row" xs={12} md={10} spacing={3} marginBottom={1} alignItems="start" justifyContent="start">
                    <Grid item xs={12} md={6}>
                        <TextBoxForm name={"sFirstName"} label={"ชื่อ"} required={true} maxLength={200} disabled={IsView} isshowTextCont={false}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextBoxForm name={"sLastName"} label={"นามสกุล"} required={true} maxLength={200} disabled={IsView} isshowTextCont={false}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextBoxForm name={"sUserName"} label={"ชื่อผู้ใช้งาน"} required={true} maxLength={50} disabled={IsView} isshowTextCont={false}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* <TextBoxForm name={"sPassword"} label={"รหัสผู้ใช้งาน"} required={true} /> */}
                        <TextBoxForm
                            name="sPassword"
                            label={"รหัสผ่าน"}
                            type={!IsTypePass ? "text" : "password"}
                            maxLength={20}
                            required={true}
                            endAdornment={
                                <>
                                    <IconButton
                                        style={{ padding: '0px' }}
                                        onClick={(() => { SetIsTypePass(!IsTypePass) })}
                                    >
                                        {IsTypePass ? <VisibilityOff /> : <RemoveRedEye />}
                                    </IconButton>
                                </>
                            }
                            disabled={IsView}
                            isshowTextCont={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextBoxForm name={"sEmail"} label={"อีเมล์"} required={true} disabled={IsView} isshowTextCont={false} maxLength={50} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextBoxForm name={"sPhone"} label={"เบอร์โทร"} required={true} disabled={IsView} isshowTextCont={false} maxLength={10} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <SelectFormItem options={ArrRoleType} name={"nRoleID"} label={"สิทธิการเข้าถึง"} required={true} disabled={IsView}/>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <RadioForm name={"IsStatus"} label={"สถานะ"} options={OptionsStatus} isShowRow disabled={IsView}/>
                    </Grid>
                </Grid>
                {/* <Grid item xs={12} md={12}>
                    <Grid item container spacing={2} justifyContent="start" alignItems="start">
                        <Grid item xs={12} md={8} spacing={2} container direction="row" justifyContent="start">
                            <Grid item >
                                <BtnBack onClick={() => { onGotoBackList(); }} />
                            </Grid>
                        </Grid>
                        {!IsView && 
                            <Grid item xs={12} md={4} spacing={2} container direction="row" justifyContent="right">
                                <Grid item >
                                    <BtnSave onClick={form.handleSubmit(() => { onSaveData(); })} />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid> */}
                <Grid item md={12} xs={12}>
                    <Grid marginTop={4} md={12} container direction="row" alignItems="center" justifyContent="center" sx={{}}>
                        <BtnCancelIcon style={{ width: "130px" }} onClick={() => { onGotoBackList() }} />
                        <BtnSaveIcon style={{ width: "130px", marginLeft: "10px" }} onClick={form.handleSubmit(() => { onSaveData(); })}/>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
    )
}